module.exports = __webpack_public_path__ + "static/img/passport.54a2498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identity/passport.jpg
// module id = YlqM
// module chunks = 0